type CSSPixels = `${string}px`;

const isValidInteger = (str: string) => {
  if (!str || str.includes(".")) return false;
  const parsed = parseInt(str, 10);
  return !isNaN(parsed) && parsed.toString() === str;
};

const addXToPixels = (pixels: CSSPixels, add: number) => {
  const [pixelNumber] = pixels.split("px");
  if (!isValidInteger(pixelNumber)) return pixels;
  return `${parseInt(pixelNumber) + add}px`;
};

const sizes: Record<string, CSSPixels> = {
  mobile: "390px",
  tablet: "768px",
  screen: "1024px",
  largeScreen: "1366px",
};

// we can hardcode the addXToPixels values to avoid adding function calls
const only = {
  mobile: `(max-width: ${sizes.mobile})`,
  tablet: `(min-width: ${addXToPixels(sizes.mobile, 1)}) and (max-width: ${
    sizes.tablet
  })`,
  screen: `(min-width: ${addXToPixels(sizes.tablet, 1)}) and (max-width: ${
    sizes.screen
  })`,
  largeScreen: `(min-width: ${addXToPixels(sizes.screen, 1)})`,
};

const upTo = {
  mobile: `(max-width: ${sizes.mobile})`,
  tablet: `(max-width: ${sizes.tablet})`,
  screen: `(max-width: ${sizes.screen})`,
  largeScreen: `(max-width: ${addXToPixels(sizes.screen, 1)})`,
};

const from = {
  mobile: `(min-width: ${sizes.mobile})`,
  tablet: `(min-width: ${sizes.tablet})`,
  screen: `(min-width: ${sizes.screen})`,
  largeScreen: `(min-width: ${addXToPixels(sizes.screen, 1)})`,
};

/**
 * HOW TO USE
 *
 * const MobileBorder = styled.div`
 *   @media only screen and ${breakpoints.only.mobile} {
 *     border: 1px solid red;
 *   }
 * `
 *
 * const LayoutStyle = styled.div`
 *   @media only screen and ${breakpoints.upTo.tablet} {
 *     flexDirection: column;
 *   }
 * `
 */
export const breakpoints = {
  only,
  upTo,
  from,
  numeric: {
    mobile: 390,
    tablet: 768,
    screen: 1024,
    largeScreen: 1366,
  } as const,
} as const;
